import { TFunction } from 'react-i18next'
import { object as yupObject } from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'
import type { AddBusinessCustomerV2FormKey } from './types'

export const useAddBusinessCustomerFormSchema = (t: TFunction) => {
  const { getRequiredYupField, getConditionalYupField } = useYupFields()

  const conditionalAddressField = (label: string) =>
    getConditionalYupField<AddBusinessCustomerV2FormKey>({
      label,
      fieldKey: 'isOperationalAddressDifferent',
      fieldValue: 'true',
    })

  return yupObject({
    useCase: getRequiredYupField({ label: t('customers.useCase') }),
    name: getRequiredYupField({ label: t('customers.businessName') }),
    entityType: getRequiredYupField({ label: t('manageBeneficiaries.entityType') }),
    registrationNumber: getRequiredYupField({ label: t('customers.registrationNumber') }),
    taxNumber: getRequiredYupField({ label: t('customers.taxIdentification') }),
    taxResidenceCountryCode: getRequiredYupField({ label: t('customers.taxResidency') }),
    naicsCode: getRequiredYupField({ label: t('customers.naicsCode') }),
    monthlyExpectedVolumes: getRequiredYupField({ label: t('customers.monthlyVolumes') }),
    incorporationDate: getRequiredYupField({ label: t('customers.incorporationDate') }),
    businessOperationsStartDate: getRequiredYupField({
      label: t('customers.businessOperationsStartDate'),
    }),
    isRegulated: getRequiredYupField({ label: t('embeddedCustomers.businessForm.isRegulated') }),
    sourceOfFunds: getRequiredYupField({ label: t('customers.sourceOfFunds') }),
    intendedUseOfAccount: getRequiredYupField({ label: t('customers.intendedUse') }),
    registeredAddressLine1: getRequiredYupField({ label: t('customers.address.addressLine1') }),
    registeredAddressCity: getRequiredYupField({ label: t('customers.address.city') }),
    registeredAddressPostalCode: getRequiredYupField({ label: t('customers.address.postalCode') }),
    registeredAddressCountryCode: getRequiredYupField({ label: t('customers.address.country') }),
    isOperationalAddressDifferent: getRequiredYupField({
      label: t('customers.isOperationalAddressDifferent'),
    }),
    operationalAddressLine1: conditionalAddressField(t('customers.address.addressLine1')),
    operationalAddressCity: conditionalAddressField(t('customers.address.city')),
    operationalAddressPostalCode: conditionalAddressField(t('customers.address.postalCode')),
    operationalAddressCountryCode: conditionalAddressField(t('customers.address.country')),
  })
}
